import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  PropertyAgentDelete,
  PropertyBusinessSourceDelete,
  PropertyCorporateDelete,
  PropertyGuaranteeCodeDelete,
  PropertyMarketSegmentDelete,
  PropertyRoomDelete,
} from "../../../Services/Service";

const createDeleteThunk = (type, service, idKey) => createAsyncThunk(
  type,
  async (id, { rejectWithValue }) => {
    try {
      const response = await service({ [idKey]: id });
      return { id, response };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Unable to delete record" },
      );
    }
  },
);

export const deletePropertyAgent = createDeleteThunk(
  "propertyAgent/deletePropertyAgent",
  PropertyAgentDelete,
  "AgentID",
);
export const deletePropertyCorporate = createDeleteThunk(
  "propertyAgent/deletePropertyCorporate", PropertyCorporateDelete, "CorporateID",
);
export const deletePropertyMarketSegment = createDeleteThunk(
  "propertyAgent/deletePropertyMarketSegment", PropertyMarketSegmentDelete, "ID",
);
export const deletePropertyBusinessSource = createDeleteThunk(
  "propertyAgent/deletePropertyBusinessSource", PropertyBusinessSourceDelete, "ID",
);
export const deletePropertyGuaranteeCode = createDeleteThunk(
  "propertyAgent/deletePropertyGuaranteeCode", PropertyGuaranteeCodeDelete, "ID",
);
export const deletePropertyRoom = createDeleteThunk(
  "propertyAgent/deletePropertyRoom", PropertyRoomDelete, "RoomID",
);

const deleteThunks = [
  deletePropertyAgent,
  deletePropertyCorporate,
  deletePropertyMarketSegment,
  deletePropertyBusinessSource,
  deletePropertyGuaranteeCode,
  deletePropertyRoom,
];

const propertyAgentSlice = createSlice({
  name: "propertyAgent",
  initialState: {
    deleting: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.pending)), (state) => {
        state.deleting = true;
        state.error = null;
      })
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.fulfilled)), (state) => {
        state.deleting = false;
      })
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.rejected)), (state, action) => {
        state.deleting = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default propertyAgentSlice.reducer;
